import { useTranslation } from 'next-i18next'
import { Ref, useRef, useState } from 'react'

import BadgeUnlockNotification from '~/shared/layouts/components/HeaderTop/components/BadgeUnlockNotification'
import FamilyDiscountNotification from '~/shared/layouts/components/HeaderTop/components/FamilyDiscountNotification'
import LinkNotifications from '~/shared/layouts/components/HeaderTop/components/LinkNotifications'
import NotificationWrapper from '~/shared/layouts/components/HeaderTop/components/NotificationWrapper'
import SystemNotification from '~/shared/layouts/components/HeaderTop/components/SystemNotification'

import { NotificationData, NotificationType } from '~/shared/types/notification.types'

export default function NotificationList({
  notificationData,
  endOfListRef,
  checklistAvailable,
}: {
  notificationData?: NotificationData[]
  endOfListRef: Ref<HTMLSpanElement>
  checklistAvailable: boolean | undefined
}): React.ReactElement {
  const { t } = useTranslation('generics')
  const parentClassNames =
    'relative w-full bg-white border-purple m-px text-black rounded-large md:hover:m-0 md:hover:border drop-shadow-lg cursor-pointer'
  const [isScrolling, setIsScrolling] = useState(false)
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleScroll = (): void => {
    if (!isScrolling) {
      setIsScrolling(true)
    }

    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current)
    }

    scrollTimeoutRef.current = setTimeout(() => {
      setIsScrolling(false)
    }, 150)
  }

  return (
    <>
      {notificationData?.length ? (
        <>
          <div
            className={`pb-2 px-1.5 mr-1 h-full ${
              checklistAvailable ? '' : 'mt-2'
            } sm:max-h-screen-4/5 overflow-x-visable overflow-y-auto util-scrollbar shop-scrollbar z-top`}
            onScroll={handleScroll}
          >
            {checklistAvailable && (
              <div
                className={`absolute w-78 h-4 ml-1.5 bg-white/50  pointer-events-none transition-opacity z-20 duration-300 ${
                  isScrolling ? 'opacity-100' : 'opacity-0'
                }`}
              />
            )}
            <div className="w-full pl-1.5 space-y-3 max-w-80 pt-4">
              {notificationData.map((data) => (
                <>
                  {data.message.title === NotificationType.SYSTEM_NOTIFICATION ? (
                    <SystemNotification data={data} parentClassNames={parentClassNames} />
                  ) : data.message.title === NotificationType.BADGE_UNLOCKED ? (
                    <NotificationWrapper createdAt={data.createdAt} parentClassNames={parentClassNames}>
                      <BadgeUnlockNotification id={data.id} isRead={data.isRead} message={data.message} />
                    </NotificationWrapper>
                  ) : data.message.title === NotificationType.FRIENDS_FAMILY_DISCOUNT ? (
                    <NotificationWrapper createdAt={data.createdAt} parentClassNames={parentClassNames}>
                      <FamilyDiscountNotification id={data.id} isRead={data.isRead} message={data.message} />
                    </NotificationWrapper>
                  ) : (
                    <LinkNotifications data={data} parentClassNames={parentClassNames} />
                  )}
                </>
              ))}
              <span ref={endOfListRef} />
            </div>
          </div>
        </>
      ) : (
        <p className="text-center pt-4">{t('noMessage')}</p>
      )}
    </>
  )
}
